import { render, staticRenderFns } from "./SaveBuildingPartPosition.vue?vue&type=template&id=bee150d2&scoped=true&"
import script from "./SaveBuildingPartPosition.vue?vue&type=script&lang=js&"
export * from "./SaveBuildingPartPosition.vue?vue&type=script&lang=js&"
import style0 from "./SaveBuildingPartPosition.vue?vue&type=style&index=0&id=bee150d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee150d2",
  null
  
)

export default component.exports